export const ID71 = () => {
    return (
        <div className="section__tab" id="naznachenie_i_funktsionalnye_vozmozhnosti_konfiguratsii"
        >
            <div className="about-card__title">
                Назначение и функциональные возможности конфигурации
            </div>
            <p>
                &nbsp;Конфигурация «1С-Рейтинг: Учет спецодежды и инвентаря» предназначена для автоматизации учета
                спецодежды и инвентаря на складе и в эксплуатации. Основные возможности конфигурации:
            </p>
            <p>
                <img src="/upload/medialibrary/381/adipgnjkqwo1sbxntf60gs4mr7xr3mfq/content-img.png"/><br/>
            </p>
            <p>
                &nbsp;В прикладном решении реализован документооборот, отражающий полный цикл движения стоимости
                спецодежды и инвентаря (поступление на склад, передача в эксплуатацию, списание, возврат на склад,
                погашение стоимости).
            </p>
            <p>
                <br/>
            </p>
            <p align="center">
                <img src="/upload/medialibrary/e26/z7l1utczuhn33u3tu46z5qkp7ra6dl2o/content-img.png"/><br/>
            </p>
            <p align="center">
                <br/>
            </p>
            <p align="center">
            </p>
            <p>
                Складской оперативный учет спецодежды и инвентаря ведется параллельно с бухгалтерским складским учетом,
                в разрезе:
            </p>
            <ul>
                <li>
                    <p>
                        организации;
                    </p>
                </li>
                <li>
                    <p>
                        структурного подразделения;
                    </p>
                </li>
                <li>
                    <p>
                        складов;
                    </p>
                </li>
                <li>
                    <p>
                        номенклатуры;
                    </p>
                </li>
                <li>
                    <p>
                        документа передачи;
                    </p>
                </li>
                <li>
                    <p>
                        назначения использования;
                    </p>
                </li>
                <li>
                    <p>
                        характеристик номенклатуры;
                    </p>
                </li>
                <li>
                    <p>
                        остаточного срока использования;
                    </p>
                </li>
                <li>
                    <p>
                        состояния спецодежды;
                    </p>
                </li>
                <li>
                    <p>
                        вида учета НУ;
                    </p>
                </li>
                <li>
                    <p>
                        документов возврата.
                    </p>
                </li>
            </ul>
            <p>
            </p>
            <br/>
            <p>
                Оперативный учет спецодежды и инвентаря в эксплуатации ведется в разрезе:
            </p>
            <p>
            </p>
            <ul>
                <li>
                    <p>
                        организации;
                    </p>
                </li>
                <li>
                    <p>
                        структурного подразделения;
                    </p>
                </li>
                <li>
                    <p>
                        подразделения организации;
                    </p>
                </li>
                <li>
                    <p>
                        номенклатуры;
                    </p>
                </li>
                <li>
                    <p>
                        документа передачи
                    </p>
                </li>
                <li>
                    <p>
                        физических лиц \ сотрудников;
                    </p>
                </li>
                <li>
                    <p>
                        назначения использования;
                    </p>
                </li>
                <li>
                    <p>
                        остаточного срока использования;
                    </p>
                </li>
                <li>
                    <p>
                        характеристик номенклатуры;
                    </p>
                </li>
                <li>
                    <p>
                        вида учета НУ.
                    </p>
                </li>
            </ul>
            <p>
                &nbsp;
            </p>
            <p>
                Учет спецодежды и инвентаря предусмотрен для следующих состояний:
            </p>
            <ul>
                <li>
                    <p>
                        Находящиеся в эксплуатации;
                    </p>
                </li>
                <li>
                    <p>
                        Находящиеся на складе (б\у);
                    </p>
                </li>
                <li>
                    <p>
                        Находящиеся на складе (новые).
                    </p>
                </li>
            </ul>
            <div>
                <br/>
            </div>
            <div>
                <p>
                    &nbsp;Предусмотрена возможность вести более детальный учет спецодежды (инвентаря) в разрезе
                    характеристик. Подхарактеристиками понимаются такие показатели, как размер обуви, размер брюк,
                    размер куртки, цвет, материал и т.д.
                </p>
                <p>
                    <br/>
                </p>
                <p>
                    <img src="/upload/medialibrary/cd2/3suoi1udcec8icnwt21abbcpj2juqchf/content-img.png"/><br/>
                </p>
                <p>
                    <br/>
                </p>
                <p>
                    &nbsp;Учет спецодежды (инвентаря) в разрезе характеристик доступен только в оперативном учете.
                </p>
                <p>
                    &nbsp;В конфигурации предусмотрена возможность регистрации неограниченного количества характеристик
                    спецодежды и инвентаря с различными типами значений (число, строка, дата, булево и множество
                    значений).
                </p>
                <p>
                    <br/>
                </p>
            </div>
            <p>
                <img src="/upload/medialibrary/ead/rq2s6828rs1upfbgn6wz0h3nx9tl3l0q/content-img.png"/>
            </p>
            <p>
                <br/>
            </p>
            <p>
                &nbsp;Если ведется учет по характеристикам, то подбор спецодежды, при передаче в эксплуатацию
                материально-ответственному лицу, может быть осуществлен по характеристикам получателя спецодежды.
            </p>
            <p>
                <br/>
            </p>
            <p>
                <img src="/upload/medialibrary/aa5/mxrf20p77xuo32209yw6eiw6q8mcaint/content-img.png"/><br/>
            </p>
            <p>
                <br/>
            </p>
            <p>
                &nbsp;В прикладном решении предусмотрена возможность описать неограниченное число видов назначения
                использования для каждой номенклатурной единицы.
            </p>
            <p>
                <br/>
            </p>
            <p>
                &nbsp;&nbsp;<img src="/upload/medialibrary/ff3/93a7zegkbjymzaeja5gfh0cz3o5s3tx5/content-img.png"/>
            </p>
            <p>
                <br/>
            </p>
            <p>
            </p>
            <p>
                &nbsp;Назначение использования определяет норматив срока использования спецодежды и инвентаря для
                автоматической подстановки в документы, способ погашения стоимости, срок полезного использования и
                способ отражения расходов в бухгалтерском учете при списании или погашении стоимости.
            </p>
            &nbsp;В качестве способа погашения стоимости может быть выбран один из трех вариантов:<br/>
            <ul>
                <li>
                    <p>
                        <b>Линейный</b> – погашение стоимости проводится пропорционально в течение срока полезного
                        использования.
                    </p>
                </li>
                <li>
                    <p>
                        <b>При передаче в эксплуатацию</b> – погашение стоимости проводится сразу при передаче в
                        эксплуатацию.
                    </p>
                </li>
                <li>
                    <p>
                        <b>Производственный</b>
                        – погашение стоимости проводится пропорционально количеству оборотов спецодежды и инвентаря в
                        производстве.
                    </p>
                </li>
            </ul>
            <div>
            </div>
            <div>
                <p>
                    &nbsp;Для линейного способа погашения стоимости в конфигурации предусмотрены настройки амортизации
                </p>
                <ul>
                    <li>
                        <p>
                            Настройки <b>Учетной политики</b>:
                        </p>
                        <ul>
                            <li>
                                <p>
                                    <b>Амортизация переданной в эксплуатацию спецодежды и инвентаря</b> –определяет
                                    порядок начисления амортизации в месяце выдачи спецодежды и инвентаря в
                                    эксплуатацию, либо в следующем месяце.
                                </p>
                            </li>
                            <li>
                                <p>
                                    <b>Амортизировать материалы на складе в месяце возврата</b>– определяет
                                    необходимость амортизации возвращенных на склад материалов в месяц возврата.
                                </p>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <p>
                <img src="/upload/medialibrary/4d9/zcsln19xy8zhem9yurwnslmcc5iqwe1w/content-img.png"/>
            </p>
            <p>
                <br/>
            </p>
            <ul>
                <li>
                    <p>
                        Настройка <b>Назначения использования</b>:
                    </p>
                    <ul>
                        <li>
                            <p>
                                <b>Приостанавливать амортизацию на время возврата</b> - определяет необходимость
                                продолжения или приостановки погашения стоимости спецодежды и инвентаря на то время,
                                пока они возвращены из эксплуатациина склад и учитываются как бывшие в употреблении.
                            </p>
                        </li>
                    </ul>
                </li>
            </ul>
            <ul>
            </ul>
            <br/>
            <br/>
            <p>
                <b>Важно!</b> Линейный способ погашения стоимости предполагает равномерное списание сумм амортизации за
                установленный срок использования спецодежды и инвентаря независимо от возвратов на склад. На расчет
                амортизации спецодежды и инвентаря в месяц возврата влияют настройка учетной политики&nbsp;<b>Амортизировать
                материалы на складе в месяце возврата </b>и настройка назначения использования <b>Приостанавливать
                амортизацию на время возврата.</b>
            </p>
            <p>
                В конфигурации предусмотрена возможность хранения информации о сроке использования и остаточной
                стоимости спецодежды (инвентаря), досрочно возвращенной на склад.
            </p>
            <p>
                Поступление спецодежды и инвентаря на склад оформляется документом <b>Поступление ТМЗ и услуг</b>.
            </p>
            <p>
                <br/>
            </p>
            <p>
                <img src="/upload/medialibrary/527/r1c8d11e38an7gqy7f1j00bd13vl4c35/content-img.png"/><br/>
            </p>
            <p>
                <br/>
            </p>
            <p>
                Для регистрации информации о количестве поступившей спецодежды (инвентаря) на склад в разрезе
                характеристик используется документ <b>Приемка спецодежды и инвентаря по характеристикам</b>, который
                может быть веден на основании документа <b>Поступление ТМЗ и услуг</b>.
            </p>
            <p>
                <br/>
            </p>
            <p>
                <img src="/upload/medialibrary/35e/4dq846nbkt44xy24nfdwx0xxng57cpik/content-img.png"/>
            </p>
            <p>
                <br/>
            </p>
            <p>
                &nbsp; &nbsp;Операции передачи спецодежды и инвентаря в эксплуатацию оформляются с помощью документа <b>Передача
                спецодежды и инвентаря в эксплуатацию</b>.
            </p>
            <p>
                <br/>
            </p>
            <p>
                <img src="/upload/medialibrary/2ec/vmevsperx1rqmn5ihkzosk5p0a42mp1j/content-img.png"/>
            </p>
            <p>
                <br/>
            </p>
            <p>
            </p>
            <p>
                Документом отражается передача в эксплуатацию как новой спецодежды и инвентаря при выборе операции <b>Первичная
                передача</b>, так и бывшей в эксплуатации при выборе операции <b>Передача материалов б\у</b>.
            </p>
            <p>
                &nbsp;Документ передачи спецодежды и инвентаря в эксплуатацию предназначен для отслеживания и
                идентификации спецодежды и инвентаря на протяжении всего периода эксплуатации, начиная с момента
                первичной передачи в эксплуатацию до полного списания.
            </p>
            <p>
                В момент проведения первичной передачи спецодежды и инвентаря в эксплуатацию в регистре накопления
                «Материалы в эксплуатации» сохраняется ссылка на документ передачи, тем самым фиксируя документ партии
                сквозного учета материалов. Данный документ передачи будет автоматически заполнятся при всех операциях,
                проводимых со спецодеждой и инвентарем и отражаться различными документами конфигурации «1С‑Рейтинг:Учет
                спецодежды и инвентаря».
            </p>
            <p>
                <br/>
            </p>
            <p>
                <img src="/upload/medialibrary/0d5/cxn9yg2sx3u8j20knbi1c0jkjs3fagp3/content-img.png"/><br/>
            </p>
            <p>
                <br/>
            </p>
            <p>
                &nbsp;Для регистрации факта возврата физическими лицами спецодежды (инвентаря) на склад используется
                документ <b>Возврат спецодежды и инвентаря из эксплуатации</b>.
            </p>
            <p>
                <br/>
            </p>
            <p>
                <img src="/upload/medialibrary/ee1/43xm8u2q2rh79u089q9xkiq8lw5rh79d/content-img.png"/><br/>
            </p>
            <p>
                <br/>
            </p>
            <p>
                &nbsp; &nbsp;Перемещение спецодежды и инвентаря между складами, либо сотрудниками отражаются для новой,
                бывшей в употреблении и находящейся в эксплуатации спецодежды и инвентаря документом <b>Перемещение
                спецодежды и инвентаря</b>.
            </p>
            <p>
                <br/>
            </p>
            <p>
                <img src="/upload/medialibrary/e78/kcbyh156i716lic9s3r5nwu77850t0a5/content-img.png"/><br/>
            </p>
            <p>
                <br/>
            </p>
            <p>
                &nbsp;Снятие с учета в подсистеме учета спецодежды и инвентарядля дальнейшей реализации физическому лицу
                проводится при установке флага <b>Снятие с учета спецодежды и инвентаря</b>.
            </p>
            <p>
                <br/>
            </p>
            <p>
                <img src="/upload/medialibrary/9df/ub359sufin6iayv6dfkbv5gptkzk27os/content-img.png"/><br/>
            </p>
            <p>
                <br/>
            </p>
            <p>
                &nbsp;Для списания спецодежды (инвентаря) по причине полного износа или по факту порчи, используется
                документ <b>Списание спецодежды и инвентаря</b>. Списание спецодежды и инвентаря проводится как со
                склада, так из эксплуатации.
            </p>
            <p>
                <br/>
            </p>
            <p>
                <img src="/upload/medialibrary/9a7/i4ei8gbj1m6u24fw422wrcmu8ticoeu4/content-img.png"/><br/>
            </p>
            <p>
                <br/>
            </p>
            <p>
                &nbsp;Для расчета амортизации производственным способом погашения стоимости в конфигурации
                предварительно фиксируется количество оборотов спецодежды и инвентаря в производстве документом <b>Выработка
                спецодежды и инвентаря</b>.
            </p>
            <p>
            </p>
            <p>
                Регламентная операция расчета амортизации и погашения срока службы спецодежды и инвентаря в конфигурации
                проводится документом <b>Погашение стоимости спецодежды и инвентаря</b>.
            </p>
            <p>
                <br/>
            </p>
            <p>
                <img src="/upload/medialibrary/062/hq6k15mfep4m4xnus1muv4cz6xrv1hb2/content-img.png"/><br/>
            </p>
            <p>
                <br/>
            </p>
            <p>
                <b>Важно!</b> Документ оформляется ежемесячнодо закрытия производственных счетов, на конец дня последней
                даты текущего месяца. На момент оформления документа операции по движениям и списаниям спецодежды и
                инвентаря должны быть завершены.
            </p>
            <p>
            </p>
            <p>
                Конфигурация «1С-Рейтинг: Учет спецодежды и инвентаря» содержит набор специализированной отчетности,
                дополняющий возможности типового решения и предназначенный для анализа результатов деятельности
                предприятия по учету спецодежды и инвентаря. В конфигурации предусмотрены следующие отчеты:
            </p>
            <ul>
                <li>
                    <p>
                        Ведомость по спецодежде и инвентарю на складе;
                    </p>
                </li>
                <li>
                    <p>
                        Ведомость по спецодежде и инвентарю в эксплуатации;
                    </p>
                </li>
                <li>
                    <p>
                        Движение материалов в эксплуатации;
                    </p>
                </li>
                <li>
                    <p>
                        Личная карточка учета материалов;
                    </p>
                </li>
                <li>
                    <p>
                        Нормы выдачи спецодежды и инвентаря;
                    </p>
                </li>
                <li>
                    <p>
                        Остатки спецодежды и инвентаря в эксплуатации;
                    </p>
                </li>
                <li>
                    <p>
                        Остатки спецодежды и инвентаря на складах;
                    </p>
                </li>
                <li>
                    <p>
                        Расчет потребности в спецодежде и инвентаре;
                    </p>
                </li>
                <li>
                    <p>
                        Списание спецодежды и инвентаря из эксплуатации;
                    </p>
                </li>
                <li>
                    <p>
                        Списание стоимости материалов.
                    </p>
                </li>
            </ul>
            <div>
                <p>
                    &nbsp;К основным отчетам подсистемы учета спецодежды и инвентаря, предоставляющим возможность
                    полного анализа движений в разрезе документов партии относятся отчеты <b>Ведомость по спецодежде и
                    инвентарю на складе</b> и <b>Ведомость по спецодежде и инвентарю в эксплуатации.</b>
                </p>
                <p>
                    <b><br/>
                    </b>
                </p>
                <p>
                    <b><img src="/upload/medialibrary/122/vdc65yqx3pyz8b59snfow3n2x5k1pddq/content-img.png"/><br/>
                    </b>
                </p>
                <p>
                    <b><br/>
                    </b>
                </p>
            </div>
            В отчете <b>Ведомость по спецодежде и инвентарю на складе</b> отражаются движения количества специальной
            одежды и инвентаря находящегося на складе за период. Движения показываются в разрезе склада, номенклатуры и
            характеристики.<br/>
            <br/>
            <p>
                <img src="/upload/medialibrary/652/yixql5lms4lcoh9m7vzk1y1b0235ahxf/content-img.png"/>
            </p>
            <p>
                &nbsp;В отчете&nbsp;<b>Ведомость по спецодежде и инвентарю в эксплуатации</b> отражаются
                количественно-суммовые движения специальной одежды и инвентаря переданной материально-ответственному
                лицу в эксплуатацию за период. Движения показываются в разрезе сотрудника\физического лица, номенклатуры
                и характеристики.
            </p>
            <p>
            </p>
        </div>
    )
}